module.exports = "<div class=\"admin-layout-wrapper\">\r\n    <router-outlet></router-outlet>\r\n</div>"